import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteFormModule } from '../form';

import { ClienteFormModalComponent } from './cliente-form-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteFormModule
    ],
    declarations: [
        ClienteFormModalComponent
    ],
    exports: [
        ClienteFormModalComponent
    ]
})
export class ClienteFormModalModule { }
